import { Fa, TextInput } from '@eltoro-ui/components'
import { useEffect } from 'react'
// import { useAppContext } from 'Contexts'
import { TableSearchType } from './useTableSearch'
import { capitalize } from 'Helpers'

export const SearchBar = (props: { type: string } & TableSearchType) => {
  // const { currentOrg } = useAppContext()

  const {
    searchInput,
    setSearchInput,
    // childOrgsOnly,
    // setChildOrgsOnly,
    // showArchived,
    // setShowArchived,
    type,
    searchType,
    setSearchType,
  } = props

  // Define search options based on type
  const getSearchOptions = () => {
    if (type.includes('partner')) {
      // Partner subscriptions don't show tags since users can't see them
      return ['name', 'id']
    }
    // All other types support name, id, and tags
    return ['name', 'id', 'tags']
  }

  const searchOptions = getSearchOptions()

  // Reset searchType if it's not available for the current type (e.g., switching from tags to partner subscriptions)
  useEffect(() => {
    if (!searchOptions.includes(searchType)) {
      setSearchType(searchOptions[0])
    }
  }, [type, searchType, searchOptions, setSearchType])

  return (
    <div className="PixelTable__search-bar tablet:flex-wrap flex items-center justify-between gap-2">
      <div className="tablet:flex-wrap flex items-center gap-2">
        <div className="relative flex">
          <select
            className="rounded-md border border-[color:var(--color-grey-200)] px-3 pl-1.5 pr-12 text-sm"
            onChange={(e) => setSearchType(e.target.value)}
            value={searchType}
          >
            {searchOptions.map((option, i) => (
              <option key={`${option}-${i}`} value={option}>
                {capitalize(option)}
              </option>
            ))}
          </select>
          <span
            aria-label="Filter by name, id, or tags"
            data-tooltip="left" // tooltip appears under back button on some instance
          >
            <Fa
              icon="filter"
              size={1}
              className="text-primary absolute right-1 cursor-pointer"
            />
          </span>
        </div>
        {/* TODO: filtering only supports one org id */}
        {/* <span
          // aria-label={(() => {
          //   if (!currentOrg?.childOrgs?.length)
          //     return 'This organization does not have child orgs.'
          //   if (childOrgsOnly) return 'Click to hide pixels from child orgs'
          //   return 'Click to include pixels from child orgs'
          // })()}
          aria-label="coming soon?"
          data-tooltip="left" // tooltip appears under back button on some instance
        >
          <Button
            iconRight={
              <Fa
                icon={childOrgsOnly ? 'square-check' : 'square'}
                size={1}
                type={!childOrgsOnly ? 'light' : undefined}
              />
            }
            className="rounded-s"
            onClick={() => setChildOrgsOnly(!childOrgsOnly)}
            // disabled={!currentOrg?.childOrgs?.length}
            disabled
            kind={childOrgsOnly ? 'primary' : undefined}
          >
            Show child orgs
          </Button>
        </span> */}
        {/* <span
          aria-label={(() => {
            // if (archiveDisabled)
            //   return 'Please clear the status filter before using archive toggle.'
            if (showArchived) return 'Click to hide archived subscriptions'
            return 'Click to include archived subscriptions'
          })()}
          data-tooltip="left"
        >
          <Button
            className="rounded-s"
            iconRight={
              <Fa
                icon={showArchived ? 'square-check' : 'square'}
                size={1}
                type={!showArchived ? 'light' : undefined}
              />
            }
            onClick={() => setShowArchived(!showArchived)}
            // disabled={archiveDisabled}
            // kind={archiveDisabled ? 'primary' : undefined}
          >
            Show archive
          </Button>
        </span> */}
      </div>
      <TextInput
        value={searchInput}
        onChange={(e) => setSearchInput(e.target.value)}
        placeholder={`Search ${type} by ${searchType}${
          searchType === 'tags' ? ' (comma-separated)' : ''
        }...`}
        iconRight={
          searchInput ? (
            <button
              onClick={() => {
                setSearchInput('')
              }}
            >
              <Fa icon="xmark" size={1} className="text-secondary" />
            </button>
          ) : (
            <Fa icon="search" size={1} className="text-primary" />
          )
        }
      />
    </div>
  )
}
